<template>
  <div class="content--sinoreg Resumo">
    <div>
      <div v-if="data.registro && data.registro.cod_motivo_alt == 30"
           class="col p-2 Resumo--bg-danger">
        <b>Registro bloqueado por Determinação Judicial</b>
      </div>
    </div>
    <header-blue v-if="data.registro != null">
      <h4 class="resumo-show_title pl-2">
        <b-row>
          <div class="d-flex align-items-center registro_title pl-3 mt-3">
            <svg class="obito-show_icon icon--md typeIcon"
                 role="presentation">
              <use :xlink:href="'#' + icons.icon_obito.id" />
            </svg>
            Óbito {{ data.registro.flag_cancelado ? "CANCELADO" : '' }}
          </div>
          <div class="registro_dados">
            <b-row>
              <b-col cols="9">
                <b-row class="justify-content-between">
                  <span class="pt-4 resumo-show_title-label">
                    {{ data.pessoa.nome }}
                  </span>
                </b-row>
                <b-row>
                  <HeaderBoxResume v-if="data.registro_id"
                                   class="matricula_id"
                                   :info="data.pessoa.cpf | cpf"
                                   text="CPF" />
                  <HeaderBoxResume v-if="data.registro_id"
                                   :info="data.registro.data_ocorrido | date"
                                   text="Data do ocorrido" />
                  <HeaderBoxResume v-if="data.registro_id"
                                   :info="data.registro.data_registro | date"
                                   text="Data de registro" />
                  <HeaderBoxResume v-if="data.registro_id"
                                   class="matricula_id"
                                   :info="data.registro.matricula | maskMatricula"
                                   text="Matrícula" />
                </b-row>
              </b-col>
              <b-col cols="3"
                     class="d-flex justify-content-end pr-4">
                <NavegacaoRegistros :prop-registro-id="data.registro_id"
                                    :prop-tipo-registro="data.registro.tipo_registro" />
              </b-col>
            </b-row>
          </div>
        </b-row>
      </h4>
    </header-blue>

    <b-tabs content-class=""
            class="Resumo-border"
            align="left"
            active-nav-item-class="Resumo--tab-active">
      <b-tab :active="tabIndex == 0"
             @click="tabIndex=0"
             @keydown.tab.prevent="tabIndex=0">
        <template v-slot:title>
          <svg class="icon--sm"
               role="presentation">
            <use :xlink:href="'#' + icons.icon_obito.id" />
          </svg>
          Resumo
        </template>

        <ResumoDetalhes v-if="data"
                        :data="data"
                        :prop-pedido-pendente="propPedidoPendente"
                        :prop-numero-pedido-possue-certidao-eletronica="numeroPedidoPossueCertidaoEletronica"
                        @reloadObito="reload" 
                        @fecharModalAvisoNumeroPedidoPossuiCertidaoEletronica="onFecharModal" />
      </b-tab>

      <b-tab :active="tabIndex == 1"
             @click="tabIndex=1">
        <template v-slot:title>
          <svg class="icon--sm"
               role="presentation">
            <use :xlink:href="'#' + icons.icon_image.id" />
          </svg>
          Imagens
        </template>

        <ResumoImagens v-if="registro_id"
                       tipo-registro="O"
                       :prop-imagens="data.registro.documentos"
                       :registro-id="registro_id"
                       @updateData="updateData" />
      </b-tab>

      <b-tab :active="tabIndex == 2"
             @click="tabIndex=2">
        <template v-slot:title>
          <svg class="icon--sm"
               role="presentation">
            <use :xlink:href="'#' + icons.icon_note.id" />
          </svg>
          Averbações/Anotações
        </template>

        <AverbacaoEProcedimento v-if="data.registro && tabIndex === 2"
                                :prop-tipo-registro="data.registro.tipo_registro"
                                :prop-registro-id="data.registro_id"
                                :prop-registro="data.registro"
                                :prop-transporte="data.registro.transporte"
                                @onTabImpressao="tabImpressao"
                                @imprimir="imprimir" />
      </b-tab>

      <!--<b-tab :active="propNovo">-->
      <b-tab :active="compNewOs || tabIndex == 3 || !!propIdOs"
             @click="tabIndex=3">
        <template v-slot:title>
          <svg class="icon--sm"
               role="presentation">
            <use :xlink:href="'#' + icons.icon_dolar.id" />
          </svg>
          Ordens de Serviços
        </template>

        <ResumoOrdensServicos v-if="registro_id && tabIndex==3"
                              :prop-registro-id="registro_id"
                              :prop-tipo="'obito'"
                              :prop-registro="data.registro"
                              :prop-data="data"
                              :prop-solicitante="solicitante"
                              :prop-novo="compNewOs"
                              :prop-os="propIdOs"
                              :prop-segunda-via="compOsSegundaVia"
                              :prop-pedido-pendente="propPedidoPendente"
                              :prop-numero-pedido-possue-ordem-servico="numeroPedidoPossueOrdemServico"
                              @onUpdateOrdemServico="updateOrdemServico"
                              @onNewOs="value => newOs = value"
                              @imprimir="imprimir" />
      </b-tab>

      <b-tab :active="tabIndex == 4"
             :disabled="data.registro && data.registro.cod_motivo_alt == 30"
             @click="tabIndex=4">
        <template v-slot:title>
          <svg class="icon--sm"
               role="presentation">
            <use :xlink:href="'#' + icons.icon_print.id" />
          </svg>
          Impressão
        </template>

        <Impressao v-if="tabIndex==4"
                   :data="data"
                   :ordem-servico="ordem_servico"
                   :prop-imprimir-os="os"
                   :prop-pedido-pendente="propPedidoPendente"
                   tipo="obito" />
      </b-tab>

      <b-tab :active="tabIndex === 5"
             @click="tabIndex = 5">
        <template v-slot:title>
          <icon-svg icon="copy"
                    class="icon--sm" />
          2ª via
        </template>

        <SegundaViaObito v-if="tabIndex === 5"
                         :prop-obito="data"
                         @changeRegistro="changeRegistro"
                         @goOS="goOS" />
      </b-tab>

      <b-tab :active="tabIndex === 6"
             @click="tabIndex = 6">
        <template v-slot:title>
          <icon-svg icon="qrcode"
                    class="icon--sm" />
          Selos
        </template>

        <ResumoSelos v-if="tabIndex === 6"
                     :prop-registro-id="data.registro_id || registro_id"
                     :prop-cpf-registrado="data.registro.pessoa.cpf"
                     :prop-nome-registrado="data.registro.pessoa.nome"
                     :prop-open-window-editar-vinculacao="propOpenWindowEditarVinculacao" />
      </b-tab>
    </b-tabs>
    <hr>
  </div>
</template>

<script>
  /* icons */
  import icon_obito from "@/assets/icons/flower.svg?sprite"
  import icon_image from "@/assets/icons/file-image.svg?sprite"
  import icon_note from "@/assets/icons/note.svg?sprite"
  import icon_dolar from "@/assets/icons/dolar.svg?sprite"
  import icon_print from "@/assets/icons/print.svg?sprite"

  /* components */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import HeaderBoxResume from "@/components/SofiaRei/Busca/HeaderBoxResume"
  import ResumoDetalhes from "@/components/SofiaRei/Resumo/Obito/ResumoDetalhes"
  import ResumoImagens from "@/components/SofiaRei/Resumo/ResumoImagens"
  import AverbacaoEProcedimento from '@/components/SofiaRei/Casamento/AverbacaoEProcedimento.vue'
  import ResumoOrdensServicos from "@/components/SofiaRei/Resumo/ResumoOrdensServicos"
  import Impressao from "@/components/SofiaRei/Resumo/Impressao/Impressao"
  import NavegacaoRegistros from '@/components/SofiaRei/NavegacaoRegistros'
  import ResumoSelos from '@/components/SofiaRei/Resumo/Selo/ResumoSelos'
  import SegundaViaObito from "@/components/SofiaRei/Obito/SegundaVia/SegundaViaObito"

  /* services */
  import ObitoService from "@/services/Registros/Obito"

  /* adapters */
  import { getDadosReceber } from '@/adapters/obitoAdapterReceber'

  /* libraries */
  import { mapGetters } from "vuex"

  /* utils */
  import { cumprirPedidos } from '@/utils/cumprirPedidos'

  import moment from 'moment'

  const tiposDocs = ['PDF', 'PDFA']

  export default {
    name: "ResumoObito",
    components: {
      ResumoDetalhes,
      Impressao,
      ResumoImagens,
      AverbacaoEProcedimento,
      ResumoOrdensServicos,
      HeaderBlue,
      HeaderBoxResume,
      NavegacaoRegistros,
      ResumoSelos,
      SegundaViaObito
    },
    props: {
      propPedidoPendente: {type: Object, default: () => {}},
      propNovo: { type: Boolean, default: () => false },
      propLegado: { type: Boolean, default: () => false },
      propObito: {type: Object, default: () => ({})},
      propMostrarTabSelos: { type: Boolean, default: () => false },
      propMostrarSelo: { type: Boolean, default: () => false },
      propOpenWindowEditarVinculacao: { type: Object, default: () => null },
      propIdOs: { type: Number, default: null}
    },
    data () {
      return {
        icons: {
          icon_obito: icon_obito,
          icon_image: icon_image,
          icon_note: icon_note,
          icon_dolar: icon_dolar,
          icon_print: icon_print
        },
        data: {},
        solicitante: {},
        ordem_servico: [],
        registro_id: null,
        tabIndex: 0,
        newOs: false,
        os: {},
        segundaVia: false,
        ordemServicoCompare: [],
        pedidoPendente: {},
        gerenciarExibicaoRecibo: false,
        numeroPedidoPossueOrdemServico: false,
        numeroPedidoPossueCertidaoEletronica: false,
        respostaModalNumeroPedidoPossuiCertidaoEletronica: ''
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        modalImpressaoEstaFechado: 'impressaoReciboOS/getModalImpressaoEstaFechado',
        recusarImpressaoReciboDeServico: 'impressaoReciboOS/getRecusarImpressaoReciboDeServico'
      }),
      compNewOs () {
        return this.newOs 
      },
      compOsSegundaVia () {
        return this.segundaVia && (this.ordemServicoCompare.length === this.ordem_servico.length)
      }
    },
    watch: {
      propObito () {
        if (Object.values(this.propObito).length) {
          this.changeRegistro(this.propObito)
          return
        }
      },
      modalImpressaoEstaFechado (novoValor) {
        this.gerenciarExibicaoRecibo = novoValor
      },
      gerenciarExibicaoRecibo (novoValor) {
        novoValor && this.tabImpressao()
      },
      recusarImpressaoReciboDeServico () {
        this.tabImpressao()
      }
    },
    created () {
      this.$watch(
        () => [this.tabIndex, this.numeroPedidoPossueOrdemServico],
        ([novoTab, novoNumero], [velhoTab, velhoNumero]) => {
          if (velhoTab !== 0 && novoTab !== 3 && velhoNumero !== false && novoNumero == true) this.numeroPedidoPossueOrdemServico = false
        },
        { immediate: false, deep: false }
      )

      this.init()
    },
    beforeMount () {
      if (this.$route.query && this.$route.query.mostrarSelos) {
        const params = {
          propMostrarSelo: true
        }

        if (this.$route.query.seloVinculador && this.$route.query.dataVinculacao) {
          params.propOpenWindowEditarVinculacao = {
            numSeloVinculador: this.$route.query.seloVinculador,
            dataVinculacao: moment(this.$route.query.dataVinculacao, 'DD-MM-YYYY-HH-mm-ss').format('YYYY-MM-DD HH:mm:ss')
          }
        }

        /**
         * Precisamos fazer um push na mesma rota, para passar as props, e para limpar a query do route, pois é imutável.
         * Se não fizermos isso, ao atualizar a página, sempre vai direcionar lá para tab de selos novamente, e queremos que o usuário navegue livremente.
         */
        this.$router.push({ name: 'resumo_obito', params: { id: this.$route.params.id, ...params } })
      }

      if (this.propIdOs) this.tabIndex = 3
    },
    methods: {
      async init (transporte) {
        loader({ text: 'Carregando...', active: true })

        try {
          this.data = await ObitoService.getObitoById(this.$route.params.id)

          this.registro_id = this.data.registro_id
          this.updateOrdemServico(this.data.registro.ordemServico)

          if (this.data.registro && this.data.registro.documentosGED) {
            // mostrar apenas permitidos
            const docsGed = this.data.registro.documentosGED.filter(documento => {
              return tiposDocs.indexOf(documento.tipo_documento) !== -1
            })
            this.data.registro.documentos =  this.data.registro.documentos.concat(docsGed)
          }

          this.setSolicitante()

          if (this.propNovo) {
            this.newOs = this.propNovo
            this.tabIndex = 3
          }

          if (this.propLegado) {
            this.newOs = this.propLegado
            this.tabIndex = 5
          }

          if (this.propMostrarSelo) {
            this.tabIndex = 6
          }

          if (!!transporte) {
            this.tabIndex = 0
          }

          if (this.propPedidoPendente) {
            this.pedidoPendente = this.propPedidoPendente
            this.tabIndex = 3

            if ((!this.propPedidoPendente.numPedidoPossueOrdemServico && !this.propPedidoPendente.numPedidoPossueCertidaoEletronica) || (!this.propPedidoPendente.numPedidoPossueOrdemServico && this.propPedidoPendente.numPedidoPossueCertidaoEletronica)) {
              this.newOs = true
            }

            if (this.propPedidoPendente.numPedidoPossueOrdemServico && !this.propPedidoPendente.numPedidoPossueCertidaoEletronica) {
              this.numeroPedidoPossueOrdemServico = true
              this.$nextTick(() => this.$bvModal.show('aviso-numero-pedido-possui-ordem-servico'))
            }

            if (this.propPedidoPendente.numPedidoPossueOrdemServico && this.propPedidoPendente.numPedidoPossueCertidaoEletronica) {
              this.tabIndex = 0
              this.numeroPedidoPossueCertidaoEletronica = true
              this.$nextTick(() => this.$bvModal.show('aviso-numero-pedido-possui-certidao-eletronica'))
            }
          }
        } catch (error) {

          if (!this.registro_id) {
            // this.$router.push('/pagina-nao-encontrada')
          }
          console.error(error)
        } finally {
          loader({ text: '', active: false })
        }
      },
      async updateData () {
        this.data = await ObitoService.getObitoById(this.$route.params.id)
      },
      updateOrdemServico (data) {
        if (data)
          this.ordem_servico = [...data]
        else
          this.ordem_servico = []
      },
      setSolicitante () {
        const [solicitante] = this.data.registro.partes.filter(parte => parte.tipo === "DECLARANTE")
        if (solicitante) {
          this.solicitante = solicitante.pessoa
        }
      },
      imprimir (os) {
        this.os = os
      },
      changeRegistro (registro) {
        const newObj = getDadosReceber(registro)

        this.data = newObj

        this.registro_id = this.data.registro_id

        if (this.data.registro && this.data.registro.documentosGED) {
          // mostrar apenas permitidos
          const docsGed = this.data.registro.documentosGED.filter(documento => {
            return tiposDocs.indexOf(documento.tipo_documento) !== -1
          })
          this.data.registro.documentos =  this.data.registro.documentos.concat(docsGed)
        }

        this.setSolicitante()

        this.newOs = false
        this.tabIndex = 0
      },
      goOS (registro) {
        this.segundaVia = true

        this.changeRegistro(registro)

        this.tabIndex = 3

        this.ordemServicoCompare = [...this.ordem_servico]
      },
      reload (transporte) {
        this.init(transporte)
      },
      tabImpressao () {
        this.tabIndex = 4
      },
      onFecharModal (status, resposta) {
        this.numeroPedidoPossueCertidaoEletronica = status
        this.respostaModalNumeroPedidoPossuiCertidaoEletronica = resposta

        if (resposta === 'Sim') {
          cumprirPedidos(this.propPedidoPendente)
        } else {
          this.tabIndex = 3
          this.numeroPedidoPossueOrdemServico = true
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_components/resumos';

  .headerBlue{
    height: 100%;
  }

  .registro {
    &_title {
      width: 12% !important;
    }

    &_dados {
      width: 85%;
    }
  }
</style>
